import { Card, Collapse, Typography } from "antd";
import { useEffect, useState } from "react";
import API_SERVICE from "shared/services/api-service";
import styled from "styled-components";
import { ellipsis } from "polished";
import Linkify from "linkify-react";
import "./help.scss";

type Props = {};
const { Title } = Typography;
const { Panel } = Collapse;

const PrivacyPolicy: React.FunctionComponent<Props> = (props) => {
  const [privacyPolicy, setPrivacyPolicy] = useState([]);
  const [dataProtectionPolicy, setDataProtectionPolicy] = useState([]);
  const [isShowMore, setIsShowMore] = useState(true);
  
  const toggleReadMore = () => setIsShowMore((show) => !show);
  
  useEffect(() => {
    getPrivacyPolicy();
    getDataProtectionPolicy();
  }, []);

  const getPrivacyPolicy = () => {
    API_SERVICE.privacyPolicy().then((data) => {
      if (data?.data?.payload?.length > 0) {
        setPrivacyPolicy(data.data.payload);
      }
    });
  };

  const getDataProtectionPolicy = () => {
    API_SERVICE.dataProtectionPolicy().then((data) => {
      if (data?.data?.payload?.length > 0) {
        setDataProtectionPolicy(data.data.payload);
      }
    });
  };

  const descMainContainer = (description: string) => {
    return (
      <MainContainer>
        <DescriptionText showMore={isShowMore}>
          <pre style={{whiteSpace: "pre-wrap", wordBreak: "break-word", fontFamily: "inherit", 
            maxHeight: isShowMore ? "200px" : "none", 
            overflow: isShowMore ? "hidden" : "visible"
          }}>
            <Linkify options={{ target: "blank" }}>
              {description}
            </Linkify>
          </pre>
        </DescriptionText>
        <ShowMoreText onClick={toggleReadMore}>
          {isShowMore ? "Show more" : "Show less"}
        </ShowMoreText>
      </MainContainer>
    );
  };

  const MainContainer = styled.div`
    padding: 0px;
  `;

  const DescriptionText = styled.div`
    font-size: 14px;
    margin-top: 20px;
    margin-bottom: 20px;
    ${({ showMore }: { showMore: boolean }) => showMore && ellipsis(undefined, 12)}
    word-break: break-word;
  `;

  const ShowMoreText = styled.div`
    color: #273896;  
    cursor: pointer;
    font-size: 14px;
    margin-top: 20px;
    margin-bottom: 20px;
    text-decoration: underline;
  `;
  
  return (
    <>
      <Card className="custom-app-card">
        <div className="faq-panel" style={{ padding: "5px", height: "77vh", overflow: "auto" }}>
          <div style={{ marginTop: "0px" }}>
            <Collapse
              defaultActiveKey={["1"]}
              ghost
              expandIconPosition="right"
            >
              <Panel header="Privacy Policy" key="1">
                {privacyPolicy.map((data: any, index) => (
                  <p key={index} style={{ paddingLeft: "15px" }}>
                    <pre style={{wordBreak:"break-word",backgroundColor:"transparent",border:"none"}}>{descMainContainer(data.description)}</pre>
                  </p>
                ))}
              </Panel>
              <Panel header="Data Protection Policy" key="2">
                {dataProtectionPolicy.map((data: any, index) => (
                  <p key={index} style={{ paddingLeft: "15px" }}>
                    <pre style={{wordBreak:"break-word",backgroundColor:"transparent",border:"none"}}>{descMainContainer(data.description)}</pre>
                  </p>
                ))}
              </Panel>
            </Collapse>
          </div>
        </div>
      </Card>
    </>
  );
};

export default PrivacyPolicy;
